App.initItems = () ->
  App.Model.Item = Backbone.Model.extend({
    urlRoot: '/cart/item'
    idAttribute: 'ean'
    total: ->
      total = @get('price') * @get('quantity')
      @set 'total', total
      total
    vat: ->
      vat = App.round(@get('price') - @get('price') / (1 + @get('vat_rate'))) * @get('quantity')
      @set 'vat', vat
      vat
  })

  App.Collection.Items = Backbone.Collection.extend({
    model: App.Model.Item
    url: '/cart/item'
    subtotal: ->
      total = 0
      @each (model) ->
        total += model.total()
        return
      total
    express: ->
      total = 0
      @each (model) ->
        total += model.get('express') * model.get('quantity')
        return
      total
    vat: ->
      vat = 0
      @each (model) ->
        vat += model.vat()
        return
      vat
  })

  App.View.Item = Backbone.View.extend({
    template: _.template($('#item-template').html())
    events: {
      'click .cart-remove-item': 'remove'
      'click .save4later-item': 'save4later'
      'change .qty': 'updateQty'
      'change .gift-wrap': 'updateGiftWrap'
    }
    initialize: ->
      # On init, render
      @render(true)
      # If this models contents change, we re-render
      @model.on 'change:quantity', (->
        @render(false)
        return
      ), this
      @model.on 'sync', ((item) ->
        App.cart.updateTotal(null)
        return
      ), this
      return
    render: (full) ->
      # Render the view with the template
      html = @template(@model.toJSON())
      if full
        el = $.parseHTML(html.trim())
        @setElement el
      else
        el = $.parseHTML(html.trim())[0]
        @$el.html el.innerHTML
      this
    remove: ->
      @$el.fadeOut 500, ->
        # Remove it from the DOM on completetion
        $(this).remove()
        App.cart.updateTotal(null)
        return
      qty =  @model.get('quantity')
      @model.destroy {
        success: (model, data) ->
          gaData = {
            currency: 'RON'
            value: data.total_products - data.total_tax - data.total_discount
            items: [
              {
                item_id: @model.get('ean')
                item_name: @model.get('title')
                discount: @model.get('discount')
                price: @model.get('price')
                quantity: qty
              }
            ]
          }
          gtag('event', 'remove_from_cart', gaData)
        }

      # Remove the model for this view from the Shopping Cart Items collection
      App.cartItems.remove @model
      if App.cartItems.length == 0
        $('.cart-header').fadeOut ->
          $('.cart-empty').fadeIn()
          return
        $('.cart-footer').fadeOut()
        $('#checkout').fadeOut()
        $('#login').fadeOut()
      return
    updateGiftWrap: ->
      gift = @$el.find('.gift-wrap')[0]
      res = @model.save({
        gift_wrap: if gift.checked then 'Y' else '',
        patch: true
        wait: true
        })
      return
    updateQty: ->
      qty = @$el.find('.qty').val()
      stock_qty = @model.get('stock_qty')
      if stock_qty != undefined and stock_qty < qty
        trpop.add {
          title: @model.get('ellipse_title')
          content: 'Ați depășit stocul maxim disponibil'
          type: 'warning'
        }
        @model.set({ quantity: stock_qty })
        @model.save({
          quantity: stock_qty ,
          patch: true
          wait: true
          })
        @render(false)
        error_wrap = $(@$el.find('.stock-error')[0])
        error_wrap.removeClass('hidden')
        return
      # if qty > 0 update it, otherwise remove
      if qty > 0
        res = @model.save({
          quantity: qty
          patch: true
          wait: true
          })
        error_wrap = $(@$el.find('.stock-error')[0])
        error_wrap.addClass('hidden')
      else
        @remove()
      return
    save4later: ->
      if !App.is_logged
        window.location.href = '/login'
      item = @model.toJSON()
      $.ajax({
        url: '/save4later/' + 'add' + '/' + item['ean']
        dataType: 'json'
        success: (data) ->
          if data.success
            App.cartItems.remove(App.cartItems.where({ ean: item['ean'] }))
            if App.cartItems.size() == 0
              App.cart.render()
              $('.cart-empty').removeClass 'hidden'
              $('#cart-items').addClass 'hidden'
              $('.cart-header').fadeOut ->
                $('.cart-empty').fadeIn()
                return
              $('.cart-footer').fadeOut()
              $('#checkout').fadeOut()
            if !App.save4laterItems
              App.save4laterItems = new (App.Collection.LaterItemsCollection)
              App.viewSave4Later = new (App.View.LaterItems)
            App.save4laterItems.add(new (App.Model.LaterItem)(item), { at: 0 })
            App.viewSave4Later.render()
            if App.save4laterItems.size() > 0
              $('#later-items-text').removeClass 'hidden'
              $('#later-items').removeClass 'hidden'
            if(App.cartItems.size() > 0)
              App.cart.render()
          else
            trpop.addgrowl {
              title: _('Salvează pentru mai târziu')
              content: _('A intervenit o problemă vă rugăm încercați mai târziu')
              type: 'warning'
            }
          return
      })
      return
  })
  App.View.ShoppingCart = Backbone.View.extend({
    el: '#cart-items'
    initialize: ->
      # make a reference to the collection this view dances with
      @collection = App.cartItems
      @render()
      return
    updateTotal: (data) ->
      if data
        App.updateShipping data
        App.updateTotals(data)
      else
        $.post '/cart/update-totals', {
        }, (data) ->
          App.updateShipping data
          App.updateTotals(data)
      return
    render: ->
      # Empty the view
      @$el.html ''
      container = document.createDocumentFragment()
      # Loop through the collection
      @collection.each ((item) ->
        # Render each item model into this List view
        newItem = new (App.View.Item)({ model: item })
        container.appendChild newItem.render().el
        # Pass this list views context
        return
      ), this
      @$el.append container
      @updateTotal()
      return
  })
